import script from "./mainForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./mainForm.vue?vue&type=script&setup=true&lang=ts"

import "./mainForm.vue?vue&type=style&index=0&id=0d6ffd1b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Gebruiker\\OneDrive\\Documents\\My Web Sites\\todo-release\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d6ffd1b"]])

export default __exports__